import { getAllProjectInstallation } from '@api/services/project-installation.service';
import useDataQuery from '@hooks/use-data-query';

export const useProjectInstallationListData = (clientInstallationId: string) => {
    const projectInstallationListQuery = useDataQuery(['project-installations', clientInstallationId], () =>
        getAllProjectInstallation(clientInstallationId)
    );

    return {
        projectInstallationList: projectInstallationListQuery.data,
        isLoading: projectInstallationListQuery.isLoading,
    };
};
